import React, { useState } from "react";
import { getGroupByName, updateGroup } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import GroupNameField from "./GroupNameField";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function EditGroupModal({ setShowModal, validationErrors, selectedGroup }) {

    const [group, setGroup] = useState(selectedGroup);

    const onSaveClick = async () => {

        const serverGroup = await getGroupByName(group.name);
        let savedGroup;

        if ((serverGroup.error && serverGroup.statusCode === 404) || serverGroup.id === group.id) {
            savedGroup = await updateGroup(group);
        } else {
            showDangerToast(`Group with name '${group.name}' already exist`, "Save Group")
        }

        if (savedGroup) {
            showSuccessToast("Group updated", "Save Group");
            setShowModal(false);
        }

    }

    return (
        <TargetTypeWizardModal
            title="Edit Group Wizard"
            subtitle="Update the selected group target type."
            onClose={() => setShowModal(false)}
            onSubmit={onSaveClick}
            submitLabel="Update"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <GroupNameField group={group} setGroup={setGroup} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(EditGroupModal);
